import { render } from "./DescriptionInput.vue?vue&type=template&id=4f368dc8&scoped=true"
import script from "./DescriptionInput.vue?vue&type=script&lang=ts"
export * from "./DescriptionInput.vue?vue&type=script&lang=ts"

import "./DescriptionInput.vue?vue&type=style&index=0&id=4f368dc8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4f368dc8"

export default script